import { createSlice } from "@reduxjs/toolkit";
import { getDistrictList, getFarmersGroupDetails, getFarmersGroupList } from "./action";

const initialState = {
  districtList: [],
  isDistrictLoading: false,
  pipeInstallation: [],
  isPipeInstallationLoading: false,
  farmersGroupList: [],
  isFarmersGroupListLoading: false,
  farmersGroupDetails: {},
  isFarmersGroupDetialsLoading: false,
};

const pipeSlice = createSlice({
  name: "pipe",
  initialState,
  reducers: {
    initPipeState(state, action) {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDistrictList.pending, (state, action) => {
        state.isDistrictLoading = true;
        state.districtList = [];
        return state;
      })
      .addCase(getDistrictList.fulfilled, (state, action) => {
        state.isDistrictLoading = false;
        state.districtList = action.payload;
        return state;
      })
      .addCase(getDistrictList.rejected, (state, action) => {
        state.isDistrictLoading = false;
      });

    builder
      .addCase(getFarmersGroupList.pending, (state, action) => {
        state.isFarmersGroupListLoading = true;
        state.farmersGroupList = [];
        return state;
      })
      .addCase(getFarmersGroupList.fulfilled, (state, action) => {
        state.isFarmersGroupListLoading = false;
        state.farmersGroupList = action.payload;
        return state;
      })
      .addCase(getFarmersGroupList.rejected, (state, action) => {
        state.isFarmersGroupListLoading = false;
      });
    builder
      .addCase(getFarmersGroupDetails.pending, (state, action) => {
        state.isFarmersGroupDetialsLoading = true;
        state.farmersGroupDetails = {};
        return state;
      })
      .addCase(getFarmersGroupDetails.fulfilled, (state, action) => {
        state.isFarmersGroupDetialsLoading = false;
        state.farmersGroupDetails = action.payload;
        return state;
      })
      .addCase(getFarmersGroupDetails.rejected, (state, action) => {
        state.isFarmersGroupDetialsLoading = false;
      });
  },
});

export const { initPipeState } = pipeSlice.actions;

export default pipeSlice.reducer;
